import React, {useEffect, useState} from 'react';
import {Button, FormControl, InputLabel, MenuItem, Select, TextField} from '@mui/material';

import './bankModal.scss';
import closeIcon from '../images/close.svg';
import {paymentService} from '../../services/payment.service';

function BankModal({close, editData = {}}: any) {
    const [data, setData] = useState({
        type: '',
        company_name: '',
        name: '',
        company: '',
        account_number: '',
        address: '',
        bank_name: '',
        iin: '',
        iik: '',
        fullname: '',
        bin: '',
        bik: '',
        kbe: '',
    });
    const [invalid, setInvalid] = useState(false);

    const types = [
        {
            id: '1',
            name: 'Юридическое лицо',
        },
        {
            id: '0',
            name: 'Физическое лицо',
        },
    ];

    useEffect(() => {
        if (editData.length) {
            paymentService.getRequisites(editData).then(el => {
                setData(data => ({...data, ...el.data.requeiste, type: el.data.type}))
            })
        }
    }, [editData])

    const submit = () => {
        if (editData) {
            if (data.type === '1') {
                paymentService.putPaymentLegal(editData, {requesite: {...data, type: 1}, type: 1}).then((data: any) => {
                    close()
                }).catch(err => {
                    setInvalid(true)
                })
            } else if (data.type === '0') {
                paymentService.putPaymentIndividual(editData, {
                    requesite: {...data, type: 0},
                    type: 0
                }).then((data: any) => close()).catch(err => {
                    setInvalid(true)
                })
            }
        } else {
            if (data.type === '1') {
                paymentService.postPaymentLegal({requesite: {...data, type: 1}, type: 1}).then((data: any) => {
                    close()
                }).catch(err => {
                    setInvalid(true)
                })
            } else if (data.type === '0') {
                paymentService.postPaymentIndividual({
                    requesite: {...data, type: 0},
                    type: 0
                }).then(() => close()).catch(err => {
                    setInvalid(true)
                })
            }
        }

    }

    return (
        <div className="modal-content">
            <button onClick={() => close()} className="close-btn">
                <img src={closeIcon} alt="close-modal"/>
            </button>
            <h3>Добавить реквизиты</h3>
            <div className="gray-form">
                <FormControl fullWidth sx={{
                    marginTop: '32px',
                }}>
                    <InputLabel id="category-label">Выберите тип</InputLabel>
                    <Select label="Выберите тип"
                            placeholder="Выберите тип"
                            value={data.type}
                            error={invalid && !data.type}
                            onChange={(e) => {
                                setData({
                                    ...data,
                                    type: String(e.target.value),
                                })
                            }}>
                        {
                            types.map((category: { id: string, name: string }, index) => {
                                return <MenuItem key={index} value={category.id}>{category.name}</MenuItem>;
                            })
                        }
                    </Select>
                    {invalid && !data.type && <span className="invalid-text">Выберите тип</span>}
                </FormControl>

                <TextField variant="outlined"
                           placeholder="Название реквизитов"
                           value={data.name}
                           sx={{
                               marginTop: '12px',
                               width: 470,
                           }}
                           onChange={(e) => {
                               setData({...data, name: e.target.value});
                           }}
                           error={invalid && !data.name}
                           helperText={invalid && !data.name ? 'Необходимо ввести название' : ''}
                           className="without-label"
                />

                {data.type === '1' && <>
                    <TextField variant="outlined"
                               placeholder="Компания"
                               sx={{
                                   marginTop: '12px',
                                   width: 470,
                               }}
                               onChange={(e) => {
                                   setData({...data, company_name: e.target.value});
                               }}
                               value={data.company_name}
                               error={invalid && !data.company_name}
                               helperText={invalid && !data.company_name ? 'Необходимо ввести название' : ''}
                               className="without-label"
                    />
                    <TextField variant="outlined"
                               placeholder="Адрес"
                               sx={{
                                   marginTop: '12px',
                                   width: 470,
                               }}
                               onChange={(e) => {
                                   setData({...data, address: e.target.value});
                               }}
                               value={data.address}
                               error={invalid && !data.address}
                               helperText={invalid && !data.address ? 'Необходимо ввести адрес' : ''}
                               className="without-label"
                    />
                    <div className="input-group">
                        <TextField variant="outlined"
                                   placeholder="БИН(ИИН)"
                                   value={data.bin}
                                   type='number'
                                   sx={{
                                       marginTop: '12px',
                                   }}
                                   onChange={(e) => {
                                       setData({...data, bin: e.target.value});
                                   }}
                                   error={invalid && !data.bin}
                                   helperText={invalid && !data.bin ? 'Необходимо ввести БИН(ИИН)' : ''}
                                   className="without-label"
                        />
                        <TextField variant="outlined"
                                   placeholder="Банк"
                                   value={data.bank_name}
                                   sx={{
                                       marginTop: '12px',
                                       marginLeft: '12px',
                                   }}
                                   onChange={(e) => {
                                       setData({...data, bank_name: e.target.value});
                                   }}
                                   error={invalid && !data.bank_name}
                                   helperText={invalid && !data.bank_name ? 'Необходимо ввести банк' : ''}
                                   className="without-label"
                        />
                    </div>
                    <TextField variant="outlined"
                               placeholder="ИИК"
                               type='number'
                               value={data.iik}
                               sx={{
                                   marginTop: '12px',
                                   width: 470,
                               }}
                               onChange={(e) => {
                                   setData({...data, iik: e.target.value});
                               }}
                               error={invalid && !data.iik}
                               helperText={invalid && !data.iik ? 'Необходимо ввести ИИК' : ''}
                               className="without-label"
                    />
                    <div className="input-group">
                        <TextField variant="outlined"
                                   placeholder="КБе"
                                   type='number'
                                   value={data.kbe}
                                   sx={{
                                       marginTop: '12px',
                                   }}
                                   onChange={(e) => {
                                       setData({...data, kbe: e.target.value});
                                   }}
                                   error={invalid && !data.kbe}
                                   helperText={invalid && !data.kbe ? 'Необходимо ввести КБе' : ''}
                                   className="without-label"
                        />
                        <TextField variant="outlined"
                                   placeholder="БИК"
                                   type='number'
                                   value={data.bik}
                                   sx={{
                                       marginTop: '12px',
                                       marginLeft: '12px',
                                   }}
                                   onChange={(e) => {
                                       setData({...data, bik: e.target.value});
                                   }}
                                   error={invalid && !data.bik}
                                   helperText={invalid && !data.bik ? 'Необходимо ввести БИК' : ''}
                                   className="without-label"
                        />
                    </div>
                </>
                }
                {data.type === '0' &&
                <>
                    <TextField variant="outlined"
                               placeholder="ФИО"
                               value={data.fullname}
                               sx={{
                                   marginTop: '12px',
                                   width: 470,
                               }}
                               onChange={(e) => {
                                   setData({...data, fullname: e.target.value});
                               }}
                               error={invalid && !data.fullname}
                               helperText={invalid && !data.fullname ? 'Необходимо ввести ФИО' : ''}
                               className="without-label"
                    />
                    <TextField variant="outlined"
                               placeholder="ИИН"
                               type='number'
                               value={data.iin}
                               sx={{
                                   marginTop: '12px',
                                   width: 470,
                               }}
                               onChange={(e) => {
                                   setData({...data, iin: e.target.value});
                               }}
                               error={invalid && !data.iin}
                               helperText={invalid && !data.iin ? 'Необходимо ввести ИИН' : ''}
                               className="without-label"
                    />
                    <TextField variant="outlined"
                               placeholder="Номер счета"
                               value={data.account_number}
                               type='number'
                               sx={{
                                   marginTop: '12px',
                                   width: 470,
                               }}
                               onChange={(e) => {
                                   setData({...data, account_number: e.target.value});
                               }}
                               error={invalid && !data.account_number}
                               helperText={invalid && !data.account_number ? 'Необходимо ввести номер счета' : ''}
                               className="without-label"
                    />
                    <div className="input-group">
                        <TextField variant="outlined"
                                   value={data.bank_name}
                                   placeholder="Наименование банка"
                                   sx={{
                                       marginTop: '12px',
                                   }}
                                   onChange={(e) => {
                                       setData({...data, bank_name: e.target.value});
                                   }}
                                   error={invalid && !data.bank_name}
                                   helperText={invalid && !data.bank_name ? 'Необходимо ввести наименование' : ''}
                                   className="without-label"
                        />
                        <TextField variant="outlined"
                                   placeholder="БИК"
                                   value={data.bik}
                                   sx={{
                                       marginTop: '12px',
                                       marginLeft: '12px',
                                   }}
                                   onChange={(e) => {
                                       setData({...data, bik: e.target.value});
                                   }}
                                   error={invalid && !data.bik}
                                   helperText={invalid && !data.bik ? 'Необходимо ввести БИК' : ''}
                                   className="without-label"
                        />
                    </div>
                </>
                }
                <Button sx={{marginTop: '24px'}} variant="contained" className="blue-btn" type="submit"
                        onClick={() => submit()} disabled={false}>Добавить реквизиты</Button>
            </div>

        </div>
    );
}

export default BankModal;
